<template>
  <div class="mgcoreset-layout">
    <v-row id="mainVRow">
      <v-col sm="4" class="left">
        <div id="myCoreSetDiv">
          <div id="mcsH1Div">
            <h1 id="mcsH1">My Core Sets</h1>
          </div>

          <v-row id="coreSetNFTListRow">
            <v-col
              sm="4"
              id="itemCol"
              v-for="(item, index) in guruCoreSetNFTs"
              :key="index"
              @click="clickGuruCoreSetNFT(item.tokenId, item.image, item.name, item.desc, item.attrs)"
            >
              <img :src="item.image" alt="Guru Core Set NFT" />
              <p id="nameP">{{ item.name }}</p>
            </v-col>
          </v-row>

          <v-pagination
            v-model="page"
            :length="pgLen"
            :total-visible="8"
            @input="onCoreSetPagination"
          ></v-pagination>
        </div>

        <div id="stakedCoreSetsDiv">
          <div id="scsH1Div">
            <h1 id="scsH1">Staked Core Sets</h1>
          </div>

          <v-row id="stakedCoreSetNFTListRow">
            <v-col
              sm="4"
              id="itemCol"
              v-for="(item, index) in stakedGuruCoreSetNFTs"
              :key="index"
              @click="clickGuruCoreSetNFT(item.tokenId, item.image, item.name, item.desc, item.attrs)"
            >
              <img :src="item.image" alt="Guru Core Set NFT" />
              <p id="nameP">{{ item.name }}</p>
            </v-col>
          </v-row>

          <v-pagination
            v-model="stakedPage"
            :length="stakedPgLen"
            :total-visible="8"
            @input="onStakedCoreSetPagination"
          ></v-pagination>
        </div>
      </v-col>
      <v-col sm="4" class="middle">
        <MgCoreSetDetail
          v-if="detailedCoreSetInfo.image !== undefined"
          :coreSetInfo="detailedCoreSetInfo"
        />
      </v-col>
      <v-col sm="4" class="right">
        <div id="stakingDiv" v-if="detailedCoreSetInfo.tokenId !== undefined">
          <v-btn
            id="refreshBtn"
            icon
            color="white"
            @click="updateGuruCoreSetInfo(detailedCoreSetInfo.tokenId)"
          >
            <img
              src="/wp-content/uploads/2022/04/AuraSyncLight.png"
              alt="refresh icon"
            />
          </v-btn>
          <div id="syncAllChkDiv">
            <v-checkbox v-model="syncAllCheckbox" color="white">
              <template v-slot:label>
                <span id="syncAllLabel">sync all?</span>
              </template>
            </v-checkbox>
          </div>
          <p id="auraInWalletP">
            <span id="labelSpan">Aura in Wallet: </span>
            <span id="valueSpan">{{ auraInWallet }}</span>
          </p>
          <p id="auraLifeTimeP">
            <span id="labelSpan">Total aura accrued since staked: </span>
            <span id="valueSpan">{{ auraLifeTime }}</span>
          </p>
          <p id="auraRewardPerHourP">
            <span id="labelSpan">Aura reward per hour: </span>
            <span id="valueSpan">{{ auraRewardPerHour }}</span>
          </p>
          <p id="auraUnclaimedP">
            <span id="labelSpan">Unclaimed aura: </span>
            <span id="valueSpan">{{ auraUnclaimed }}</span>
          </p>
          <p id="stakedPeriodP">
            <span id="labelSpan">Staked Days: </span>
            <span id="valueSpan">{{ stakedDays }}</span>
          </p>
          <p id="levelP">
            <span id="labelSpan">Level: </span>
            <span id="valueSpan">{{ coreSetLevel }}</span>
          </p>
          <v-progress-linear
            v-if="isCoreSetStaked == 1"
            id="vLevelPB"
            color="light-green"
            height="10"
            :value="levelPBVal"
            striped
          ></v-progress-linear>
          <p id="lastStakingUpdateP" v-if="lastStakingUpdateAt != ''">
            <span id="labelSpan">Shrine entry was: </span>
            <span id="valueSpan">{{ lastStakingUpdateAt }}</span>
          </p>

          <p id="sendGuruP">Send Guru to Shrine?</p>
          <div
            v-if="isCoreSetApproved == 0 && isCoreSetStaked == 0"
            id="approveDiv"
          >
            <v-btn
              id="approveBtn"
              rounded
              color="primary"
              dark
              @click="ApproveCoreSetNFT(detailedCoreSetInfo.tokenId)"
              :disabled="approveBtnLabel == 'Processing Approval...'"
              >{{ approveBtnLabel }}</v-btn
            >
          </div>
          <div
            v-if="isCoreSetApproved == 1 || isCoreSetStaked == 1"
            id="switchDiv"
          >
            <span id="noSpan">NO</span>
            <v-switch
              id="stakeVswitch"
              v-model="willStakeCoreSet"
              inset
              @click="toggleStakeSwitch()"
            ></v-switch>
            <span id="yesSpan">YES</span>
          </div>
          <p id="meditateP">
            <span v-if="!willStakeCoreSet"
              >Your Core Set is not meditating...</span
            >
            <span v-if="willStakeCoreSet">Your Core Set is meditating!</span>
          </p>

          <div id="btnDiv">
            <v-btn
              id="claimBtn"
              depressed
              color="primary"
              @click="claimAura(detailedCoreSetInfo.tokenId)"
              >Claim {{ auraUnclaimed }} Aura</v-btn
            >
          </div>

          <div id="btnDiv">
            <v-btn
              id="claimBtn"
              depressed
              color="primary"
              @click="claimAllAura(detailedCoreSetInfo.tokenId)"
              >Claim All Aura</v-btn
            >
          </div>

          <p id="lastUpdateP" v-if="lastUpdateAt != ''">
            <span id="labelSpan">Last update: </span>
            <span id="valueSpan">{{ lastUpdateAt }}</span>
          </p>
        </div>

        <!-- <div
          id="levelUpNFTsDiv"
          v-if="detailedCoreSetInfo.tokenId !== undefined && isStaked == true"
        >
          <h1 id="levelUpH1">My Level Up NFTs</h1>

          <v-row id="levelUpNFTRow">
            <v-col
              sm="4"
              id="itemCol"
              v-for="(item, index) in levelUpNFTs"
              :class="selectedLevelUpInfo.tokenId === item.tokenId"
              :key="index"
              @click="clickLevelUpNFT(item.tokenId, item.image, item.name, item.desc)"
            >
              <img :src="item.image" alt="Level Up NFT" />
              <p id="nameP">{{ item.name }}</p>

              <div
                id="btnsDiv"
                v-if="selectedLevelUpInfo.tokenId !== undefined && selectedLevelUpInfo.tokenId === item.tokenId"
              >
                <v-btn
                  v-if="isLevelUpNFTApproved === 0 || isLevelUpNFTApproved === undefined"
                  id="approveLevelUpBtn"
                  small
                  depressed
                  color="primary"
                  @click="approveLevelUpNFT(selectedLevelUpInfo.tokenId)"
                  >Approve</v-btn
                >
                <v-btn
                  v-if="isLevelUpNFTApproved === 1 && detailedCoreSetInfo.tokenId !== undefined"
                  id="attachLevelUpBtn"
                  small
                  depressed
                  color="primary"
                  @click="attachLevelUpNFT(selectedLevelUpInfo.tokenId, detailedCoreSetInfo.tokenId)"
                  >Attach</v-btn
                >
              </div>
            </v-col>
          </v-row>

          <v-pagination
            v-model="levelUpPage"
            :length="levelUpPagLen"
            :total-visible="8"
            @input="onLevelUpPagination"
          ></v-pagination>
        </div> -->
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Web3 from 'web3';
import BigNumber from 'bignumber.js';
import moment from 'moment';

const RealShrineConstants = require('../../constants/realShrine');
const guruCoreSetNFTAbi = require("../../constants/abis/guruCoreSetNFT.json");
const auraTokenAbi = require("../../constants/abis/auraToken.json");
const coreSetStakingProxyNFTAbi = require("../../constants/abis/coreSetStakingProxyNFT.json");
const levelUpNFTAbi = require("../../constants/abis/levelUpNFT.json");

import { sendGetRequest } from '../../utils/axios';
import { toNumberWithThousandSeparator } from '../../utils/general';

import MgCoreSetDetail from './MgCoreSetDetail';

export default {
  name: 'MgCoreSet',
  emits: [],
  components: {
    MgCoreSetDetail,
  },
  data: () => ({
    ownedCoreSetNFTCnt: 0,
    guruCoreSetNFTs: [],
    stakedGuruCoreSetNFTCnt: 0,
    stakedGuruCoreSetNFTs: [],
    detailedCoreSetInfo: {},
    // level up NFT related. eros god
    selectedLevelUpInfo: {},
    isLevelUpNFTApproved: 0,
    levelUpPage: 1,
    levelUpPagLen: 0,
    levelUpContractInterface: '',
    ownedLevelUpNFTCnt: 0,
    levelUpPerPage: 3,
    levelUpNFTs: [],
    // Staked information. eros god
    lastStakingUpdateAt: '',
    levelPBVal: 0,
    lastUpdateAt: '',
    auraInWallet: 0,
    auraLifeTime: 0,
    auraRewardPerHour: 0,
    auraUnclaimed: 0,
    coreSetNFTInfoUpdateDates: [],
    stakedDays: 0,
    approveBtnLabel: 'Approve',
    coreSetLevel: 0,
    syncAllCheckbox: false,
    isStaked: 0,
    // Pagination related. eros god
    perPage: 9,
    pgLen: 0,
    stakedPgLen: 0,
    page: 1,
    stakedPage: 1,
    // Contract variables. eros god
    web3: '',
    guruCoreSetContractInterface: '',
    auraContractInterface: '',
    coreSetStakingContractInterface: '',
    currentAccount: '',
    isCoreSetApproved: 0,
    isCoreSetStaked: 0,
    willStakeCoreSet: false,
    // WordPress bind data. eros god
    wpData: wpData,
  }),
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (typeof window.ethereum === 'undefined') return;

      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
      this.currentAccount = accounts[0];

      const web3js = window.web3;
      if (typeof web3js === 'undefined') return;

      this.web3 = new Web3(web3js.currentProvider);

      this.web3.eth.defaultAccount = this.currentAccount;

      this.guruCoreSetContractInterface = this.web3.eth.contract(guruCoreSetNFTAbi).at(wpData.GURU_CORE_SET_NFT_CONTRACT_ADDRESS);
      this.auraContractInterface = this.web3.eth.contract(auraTokenAbi).at(wpData.AURA_TOKEN_CONTRACT_ADDRESS);
      this.coreSetStakingContractInterface = this.web3.eth.contract(coreSetStakingProxyNFTAbi).at(wpData.CORE_SET_STAKING_CONTRACT_ADDRESS);
      this.levelUpContractInterface = this.web3.eth.contract(levelUpNFTAbi).at(wpData.LEVEL_UP_NFT_CONTRACT_ADDRESS);

      let _this = this;
      this.guruCoreSetContractInterface.balanceOf.call(this.currentAccount, function(err, res) {
        if (!err) {
          _this.ownedCoreSetNFTCnt = new BigNumber(res).toNumber();

          if (_this.ownedCoreSetNFTCnt > 0) {
            let forEnd = _this.perPage;
            if (forEnd > _this.ownedCoreSetNFTCnt) forEnd = _this.ownedCoreSetNFTCnt;

            for (let i=0; i<forEnd; i++) {
              _this.getGuruCoreSetNFTInfos(i);
            }
          }

          _this.pgLen = (_this.ownedCoreSetNFTCnt % _this.perPage) > 0 ?  Math.floor(_this.ownedCoreSetNFTCnt / _this.perPage) + 1 : _this.ownedCoreSetNFTCnt / _this.perPage;
        } else {
          console.log(err.code);
        }
      });

      this.coreSetStakingContractInterface.getStakedNFTCountByStaker.call(this.currentAccount, function(err, res) {
        if (err) { console.log(err.code); return; }

        _this.stakedGuruCoreSetNFTCnt = new BigNumber(res).toNumber();

        if (_this.stakedGuruCoreSetNFTCnt > 0) {
          let forEnd = _this.perPage;
          if (forEnd > _this.stakedGuruCoreSetNFTCnt) forEnd = _this.stakedGuruCoreSetNFTCnt;

          for (let i=0; i<forEnd; i++) {
            _this.getStakedGuruCoreSetNFTInfos(i);
          }
        }

        _this.stakedPgLen = (_this.stakedGuruCoreSetNFTCnt % _this.perPage) > 0 ?  Math.floor(_this.stakedGuruCoreSetNFTCnt / _this.perPage) + 1 : _this.stakedGuruCoreSetNFTCnt / _this.perPage;
      });

      this.levelUpContractInterface.balanceOf.call(this.currentAccount, function(err, res) {
        if (!err) {
          _this.ownedLevelUpNFTCnt = new BigNumber(res).toNumber();

          if (_this.ownedLevelUpNFTCnt > 0) {
            let forEnd = _this.levelUpPerPage;
            if (forEnd > _this.ownedLevelUpNFTCnt) forEnd = _this.ownedLevelUpNFTCnt;

            for (let i=0; i<forEnd; i++) {
              _this.getLevelUpNFTInfos(i);
            }
          }

          _this.levelUpPagLen = (_this.ownedLevelUpNFTCnt % _this.levelUpPerPage) > 0 ?  Math.floor(_this.ownedLevelUpNFTCnt / _this.levelUpPerPage) + 1 : _this.ownedLevelUpNFTCnt / _this.levelUpPerPage;
        } else {
          console.log(err.code);
        }
      });
    },
    getGuruCoreSetNFTInfos(pIndex) {
      let _this = this;

      this.guruCoreSetContractInterface.tokenOfOwnerByIndex.call(this.currentAccount, pIndex, function(err, res) {
        if (err) { console.log(err.code); return; }

        let tokenId = res;
        _this.guruCoreSetContractInterface.tokenURI.call(tokenId, function(err, res) {
          if (err) { console.log(err.code); return; }

          let tokenURI = res;
          sendGetRequest(tokenURI).then((tokenInfo) => {
            _this.guruCoreSetNFTs.push({tokenId: tokenId, name: tokenInfo.data.name, desc: tokenInfo.data.description, image: tokenInfo.data.image, attrs: tokenInfo.data.attributes });
          });
        });
      });
    },
    getStakedGuruCoreSetNFTInfos(pIndex) {
      let _this = this;

      this.coreSetStakingContractInterface.getStakedNFTTokenIdsByStaker.call(this.currentAccount, function(err, res) {
        if (err) { console.log(err.code); return; }

        let stakedCnt = res.length;
        if (stakedCnt === 0) return;

        let tokenId = res[pIndex];
        _this.guruCoreSetContractInterface.tokenURI.call(res[pIndex], function(err, res) {
          if (err) { console.log(err.code); return; }

          let tokenURI = res;
          sendGetRequest(tokenURI).then((tokenInfo) => {
            _this.stakedGuruCoreSetNFTs.push({tokenId: tokenId, name: tokenInfo.data.name, desc: tokenInfo.data.description, image: tokenInfo.data.image, attrs: tokenInfo.data.attributes });
          });
        });
      });
    },
    getLevelUpNFTInfos(pIndex) {
      let _this = this;

      this.levelUpContractInterface.tokenOfOwnerByIndex.call(this.currentAccount, pIndex, function(err, res) {
        if (err) { console.log(err.code); return; }

        let tokenIndex = res;
        _this.levelUpContractInterface.tokenURI.call(tokenIndex, function(err, res) {
          if (err) { console.log(err.code); return; }

          let tokenURI = res;
          sendGetRequest(tokenURI).then((tokenInfo) => {
            _this.levelUpNFTs.push({tokenId: tokenIndex, name: tokenInfo.data.name, desc: tokenInfo.data.description, image: tokenInfo.data.image });
          });
        });
      });
    },
    clickGuruCoreSetNFT(pTokenId, pNftImgUrl, pNftName, pNftDesc, pNftAttrs) {
      this.detailedCoreSetInfo = {};

      this.detailedCoreSetInfo.tokenId = pTokenId;
      this.detailedCoreSetInfo.image = pNftImgUrl;
      this.detailedCoreSetInfo.name = pNftName;
      this.detailedCoreSetInfo.desc = pNftDesc;
      this.detailedCoreSetInfo.attrs = pNftAttrs;

      this.lastStakingUpdateAt = '';
      this.levelPBVal = 0;

      this.updateStatistics(pTokenId);

      let _this = this;

      this.guruCoreSetContractInterface.getApproved.call(pTokenId, function(err, res) {
        if (err) { console.log(err.code); return; }

        if (res === wpData.CORE_SET_STAKING_CONTRACT_ADDRESS.toLowerCase().trim()) {
          _this.isCoreSetApproved = 1;
        } else {
          _this.isCoreSetApproved = 0;
        }
      });

      this.coreSetStakingContractInterface.isNFTStaked.call(pTokenId, function(err, res) {
        if (err) { console.log(err.code); return; }

        _this.isCoreSetStaked = res;
        if (_this.isCoreSetStaked)
          _this.willStakeCoreSet = true;
        else
          _this.willStakeCoreSet = false;
      });

      this.lastUpdateAt = this.coreSetNFTInfoUpdateDates[pTokenId] == undefined ? '' : this.coreSetNFTInfoUpdateDates[pTokenId];
    },
    clickLevelUpNFT(pTokenId, pNftImgUrl, pNftName, pNftDesc) {
      this.selectedLevelUpInfo = {};

      this.selectedLevelUpInfo.tokenId = pTokenId;
      this.selectedLevelUpInfo.image = pNftImgUrl;
      this.selectedLevelUpInfo.name = pNftName;
      this.selectedLevelUpInfo.desc = pNftDesc;

      let _this = this;
      this.levelUpContractInterface.getApproved.call(pTokenId, function(err, res) {
        if (err) { console.log(err.code); return; }

        if (res === wpData.STAKING_PROXY_NFT_CONTRACT_ADDRESS.toLowerCase().trim()) {
          _this.isLevelUpNFTApproved = 1;
        } else {
          _this.isLevelUpNFTApproved = 0;
        }
      });
    },
    onCoreSetPagination() {
      this.guruCoreSetNFTs = [];
      this.detailedCoreSetInfo = {};

      if (this.ownedCoreSetNFTCnt <= 0) return;

      let startIndex = (this.page - 1) * this.perPage;
      let endIndex = (startIndex + this.perPage) < this.ownedCoreSetNFTCnt ? startIndex + this.perPage : this.ownedCoreSetNFTCnt;

      let _this = this;
      for (let i=startIndex; i<endIndex; i++) {
        this.guruCoreSetContractInterface.tokenOfOwnerByIndex.call(this.currentAccount, i, function(err, res) {
          if (err) { console.log(err.code); return; }

          let tokenId = res;
          _this.guruCoreSetContractInterface.tokenURI.call(tokenId, function(err, res) {
            if (err) { console.log(err.code); return; }

            let tokenURI = res;
            sendGetRequest(tokenURI).then((tokenInfo) => {
              _this.guruCoreSetNFTs.push({
                tokenId: tokenId,
                image: tokenInfo.data.image,
                name: tokenInfo.data.name,
                desc: tokenInfo.data.description,
                attrs: tokenInfo.data.attributes });
            });
          });
        });
      }
    },
    onStakedCoreSetPagination() {
      this.stakedGuruCoreSetNFTs = [];
      this.detailedCoreSetInfo = {};

      if (this.stakedGuruCoreSetNFTCnt <= 0) return;

      let startIndex = (this.stakedPage - 1) * this.perPage;
      let endIndex = (startIndex + this.perPage) < this.stakedGuruCoreSetNFTCnt ? startIndex + this.perPage : this.stakedGuruCoreSetNFTCnt;

      let _this = this;
      for (let i=startIndex; i<endIndex; i++) {
        this.coreSetStakingContractInterface.getStakedNFTTokenIdsByStaker.call(this.currentAccount, function(err, res) {
          if (err) { console.log(err.code); return; }

          let stakedCnt = res.length;
          if (stakedCnt === 0) return;

          let tokenId = res[i];
          _this.guruCoreSetContractInterface.tokenURI.call(tokenId, function(err, res) {
            if (err) { console.log(err.code); return; }

            let tokenURI = res;
            sendGetRequest(tokenURI).then((tokenInfo) => {
              _this.stakedGuruCoreSetNFTs.push({
                tokenId: tokenId,
                image: tokenInfo.data.image,
                name: tokenInfo.data.name,
                desc: tokenInfo.data.description,
                attrs: tokenInfo.data.attributes });
            });
          });
        });
      }
    },
    updateGuruCoreSetInfo(pTokenId) {
      if (this.syncAllCheckbox) {
        this.syncAll();
        return;
      }

      let _this = this;
      this.coreSetStakingContractInterface.isNFTStaked.call(pTokenId, function(err, res) {
        if (err) { console.log(err.code); return; }

        _this.isStaked = res;
        if (!_this.isStaked) {
          _this.updateStatistics(pTokenId);

          _this.coreSetNFTInfoUpdateDates[pTokenId] = moment().format("MM/DD/YYYY");
          _this.lastUpdateAt = _this.coreSetNFTInfoUpdateDates[pTokenId];
        } else {
          _this.coreSetStakingContractInterface.updateRewardOfSelectedNFT(pTokenId, function(err) {
            if (err) { console.log(err.code); return; }

            _this.updateStatistics(pTokenId);

            _this.coreSetNFTInfoUpdateDates[pTokenId] = moment().format("MM/DD/YYYY");
            _this.lastUpdateAt = _this.coreSetNFTInfoUpdateDates[pTokenId];
          });
        }
      });
    },
    updateStatistics(pTokenId) {
      let _this = this;

      this.auraContractInterface.balanceOf.call(this.currentAccount, function (err, res) {
        if (err) { console.log(err.code); return; }

        _this.auraInWallet = toNumberWithThousandSeparator(res / 1000000000000000000);
      });

      this.coreSetStakingContractInterface.getLevelOfStakedNFT.call(pTokenId, function(err, res) {
        if (err) { console.log(err.code); return; }

        _this.coreSetLevel = res;
      });

      this.coreSetStakingContractInterface.getRewardPerHour.call(pTokenId, function(err, res) {
        if (err) { console.log(err.code); return; }

        _this.auraRewardPerHour = toNumberWithThousandSeparator(res / 1000000000000000000);
      });

      this.coreSetStakingContractInterface.isNFTStaked.call(pTokenId, function(err, res) {
        if (err) { console.log(err.code); return; }

        _this.isStaked = res;
        if (_this.isStaked) {
          _this.coreSetStakingContractInterface.getRewardLifeTimeOfStakedNFT.call(pTokenId, function(err, res) {
            if (err) { console.log(err.code); return; }

            _this.auraLifeTime = toNumberWithThousandSeparator(res / 1000000000000000000);
          });

          _this.coreSetStakingContractInterface.getRewardOfStakedNFT.call(pTokenId, function(err, res) {
            if (err) { console.log(err.code); return; }

            _this.auraUnclaimed = toNumberWithThousandSeparator(res / 1000000000000000000);
          });

          _this.coreSetStakingContractInterface.getStakedTimeOfNFT.call(pTokenId, function(err, res) {
            if (err) { console.log(err.code); return; }

            let currentTimeStamp = Math.round(moment().valueOf() / 1000);
            let tsDiff = currentTimeStamp - res;
            _this.stakedDays = Math.floor(tsDiff / 86400);
            tsDiff = tsDiff - _this.stakedDays * 86400;
            _this.stakedDays = _this.stakedDays % RealShrineConstants.CORE_SET_NFT_LEVELUP_DEADLINE_DAYS;

            _this.levelPBVal = Math.floor(_this.stakedDays / RealShrineConstants.CORE_SET_NFT_LEVELUP_DEADLINE_DAYS * 100);

            let stakedHours = Math.floor(tsDiff / 3600);

            tsDiff = tsDiff - stakedHours * 3600;
            let stakedMins = Math.floor(tsDiff / 60);

            if (_this.stakedDays > 1)
              _this.lastStakingUpdateAt = _this.stakedDays + " days, ";
            else
              _this.lastStakingUpdateAt = _this.stakedDays + " day, ";

            if (stakedHours > 1)
              _this.lastStakingUpdateAt += stakedHours + " hours, ";
            else
              _this.lastStakingUpdateAt += stakedHours + " hour, ";

            if (stakedMins > 1)
              _this.lastStakingUpdateAt += stakedMins + " minutes ";
            else
              _this.lastStakingUpdateAt += stakedMins + " minute ";

            _this.lastStakingUpdateAt += "ago"
          });
        } else {
          _this.auraLifeTime = 0;
          _this.auraUnclaimed = 0;
          _this.stakedDays = 0;
        }
      });
    },
    ApproveCoreSetNFT(pTokenId) {
      let _this = this;

      this.guruCoreSetContractInterface.approve(wpData.CORE_SET_STAKING_CONTRACT_ADDRESS, pTokenId, function(err) {
        _this.approveBtnLabel = "Processing Approval...";

        setTimeout(() => {
          _this.approveBtnLabel = "Approve";

          if (!err) {
            _this.isCoreSetApproved = 1;
          } else {
            console.log('Approving failed.', err.code);
          }
        }, 8000);
      });
    },
    approveLevelUpNFT(pTokenId) {
      let _this = this;

      this.levelUpContractInterface.approve(wpData.STAKING_PROXY_NFT_CONTRACT_ADDRESS, pTokenId, function(err) {
        if (!err) {
          _this.isLevelUpNFTApproved = 1;
        } else {
          console.log('Approving failed.', err.code);
          _this.isLevelUpNFTApproved = 0;
        }
      });
    },
    toggleStakeSwitch() {
      if (this.detailedCoreSetInfo === {}) return;

      if (!this.willStakeCoreSet) {
        this.unstakeCoreSetNFT(this.detailedCoreSetInfo.tokenId);
      } else {
        this.stakeCoreSetNFT(this.detailedCoreSetInfo.tokenId);
      }
    },
    unstakeCoreSetNFT(pTokenId) {
      let _this = this;
      this.coreSetStakingContractInterface.unstake(pTokenId, function(err) {
        if (!err) {
          console.log('Successfully unstaked token id: ', pTokenId);

          _this.auraLifeTime = 0;
          _this.auraUnclaimed = 0;
          _this.lastStakingUpdateAt = '';

          location.reload();
        } else {
          console.log(err.code);
        }
      });
    },
    stakeCoreSetNFT(pTokenId) {
      let _this = this;
      this.coreSetStakingContractInterface.stake(pTokenId, function(err) {
        if (!err) {
          console.log("Successfully staked token id: ", pTokenId);

          _this.updateStatistics(pTokenId);

          location.reload();
        } else {
          console.log('Staking failed.', err.code);
        }
      });
    },
    claimAura(pTokenId) {
      if (this.detailedCoreSetInfo === {}) return;

      let _this = this;

      this.coreSetStakingContractInterface.isNFTStaked.call(pTokenId, function(err, res) {
        if (err) { console.log(err.code); return; }

        _this.isStaked = res;
        if (_this.isStaked) {
          _this.coreSetStakingContractInterface.claimReward(pTokenId, function(err) {
            if (!err) {
              console.log('Successfully claimed reward');

              _this.updateStatistics(pTokenId);
            } else {
              console.log(err.code);
            }
          });
        }
      });
    },
    claimAllAura(pTokenId) {
      if (this.detailedCoreSetInfo === {}) return;

      let _this = this;

      let currentAccount = this.currentAccount;

      this.coreSetStakingContractInterface.isNFTStaked.call(pTokenId, function(err, res) {
        if (err) { console.log(err.code); return; }

        _this.isStaked = res;
        if (_this.isStaked) {
          _this.coreSetStakingContractInterface.claimAll(function(err) {
            if (!err) {
              console.log('Successfully claimed all rewards');

              _this.updateStatistics(pTokenId);
            } else {
              console.log(err.code);
            }
          });
        }
      });
    },
    syncAll() {
      if (!this.syncAllCheckbox) return;

      let _this = this;
      this.coreSetStakingContractInterface.getStakedNFTTokenIdsByStaker.call(this.currentAccount, function(err, res) {
        if (err) { console.log(err.code); return; }

        let tokenIds = res;
        _this.coreSetStakingContractInterface.syncAll(tokenIds, function(err, res) {
          if (err) { console.log(err.code); return; }

          console.log('Successfully synced all!');
        });
      });
    },
    claimAll() {
      let _this = this;
      this.coreSetStakingContractInterface.getStakedNFTTokenIdsByStaker.call(this.currentAccount, function(err, res) {
        if (err) { console.log(err.code); return; }

        let tokenIds = res; console.log('staked Token Ids: ', tokenIds);
        _this.coreSetStakingContractInterface.claimAll(tokenIds, function(err, res) {
          if (err) { console.log(err.code); return; }

          console.log('Successfully claimed all!');
        });
      });
    },
    attachLevelUpNFT(pLevelUpTokenId, pCoreSetTokenId) {
      let _this = this;
      this.levelUpContractInterface.getLevelOfNFT.call(pLevelUpTokenId, function(err) {
        if (err) { console.log(err.code); return; }

        _this.coreSetStakingContractInterface.attachLevelUpNftToCoreSetGuru(pLevelUpTokenId, pCoreSetTokenId, function(err) {
          if (err) { console.log(err.code); return; }

          location.reload();
        });
      });
    },
    onLevelUpPagination() {
      this.levelUpNFTs = [];
      this.selectedLevelUpInfo = {};

      if (this.ownedLevelUpNFTCnt <= 0) return;

      let startIndex = (this.levelUpPage - 1) * this.levelUpPerPage;
      let endIndex = (startIndex + this.levelUpPerPage) < this.ownedLevelUpNFTCnt ? startIndex + this.levelUpPerPage : this.ownedLevelUpNFTCnt;

      let _this = this;
      for (let i=startIndex; i<endIndex; i++) {
        this.levelUpContractInterface.tokenOfOwnerByIndex.call(this.currentAccount, i, function(err, res) {
          if (err) { console.log(err.code); return; }

          let tokenId = res;

          _this.levelUpContractInterface.tokenURI.call(tokenId, function(err, res) {
            if (err) { console.log(err.code); return; }

            let tokenURI = res;

            sendGetRequest(tokenURI).then((tokenInfo) => {
              _this.levelUpNFTs.push({
                tokenId: tokenId,
                image: tokenInfo.data.image,
                name: tokenInfo.data.name,
                desc: tokenInfo.data.description,
              });
            });
          });
        });
      }
    },
  },
  computed: {

  },
  watch: {

  }
};
</script>

<style scoped>
.mgcoreset-layout p {
  margin: 0px;
}

#mcsH1Div {
  background-image: url(https://dev.mysticgurus.club/wp-content/uploads/2022/02/woodsign.svg);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  text-align: center;
}
#mcsH1Div #mcsH1 {
  font-weight: 600;
  text-shadow: 2px 2px 3px rgb(255 255 255 / 30%);
  font-family: Architects Daughter;
  padding: 5px;
}

#coreSetNFTListRow {
  margin-top: 20px;
}
#coreSetNFTListRow #itemCol img {
  width: 100%;
  box-shadow: 0px 0px 40px -1px rgb(0 0 0 / 43%);
  border-radius: 7px;
}
#coreSetNFTListRow #itemCol #nameP {
  text-align: center;
  color: #ffffff;
  font-weight: 600;
  font-family: Architects Daughter;
}

#stakedCoreSetsDiv {
  margin-top: 35px;
}
#stakedCoreSetsDiv #stakedCoreSetNFTListRow {
  margin-top: 20px;
}
#stakedCoreSetsDiv #stakedCoreSetNFTListRow #itemCol img {
  width: 100%;
  box-shadow: 0px 0px 40px -1px rgb(0 0 0 / 43%);
  border-radius: 7px;
}
#stakedCoreSetsDiv #stakedCoreSetNFTListRow #itemCol #nameP {
  text-align: center;
  color: #ffffff;
  font-weight: 600;
  font-family: Architects Daughter;
}

#scsH1Div {
  background-image: url(https://dev.mysticgurus.club/wp-content/uploads/2022/02/woodsign.svg);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 350px;
  text-align: center;
}
#scsH1Div #scsH1 {
  font-weight: 600;
  text-shadow: 2px 2px 3px rgb(255 255 255 / 30%);
  font-family: Architects Daughter;
}

#stakingDiv {
  background-color: #333;
  border-radius: 29px;
  padding: 20px 30px;
  margin-top: 20px;
  position: relative;
}
#stakingDiv #refreshBtn {
  float: right;
  background-color: transparent;
  position: absolute;
  right: 20px;
  top: 15px;
  display: block;
  width: 65px;
  height: 65px;
}
#stakingDiv #refreshBtn img {
  width: 100%;
}
#stakingDiv #refreshBtn img:hover {
  filter: brightness(120%);
}
#stakingDiv #labelSpan {
  color: #cc99ff;
}
#stakingDiv #valueSpan {
  color: white;
}
#stakingDiv #vLevelPB {
  margin-top: 10px;
  margin-bottom: 10px;
}
#stakingDiv #sendGuruP {
  text-align: center;
  color: #ffffff;
  letter-spacing: 1.8px;
  text-shadow: 0px 0px 4px #fffeab;
  font-family: Architects Daughter;
  font-size: 25px;
  margin-top: 30px;
}
#stakingDiv #approveDiv {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 15px;
}
#stakingDiv #approveDiv #approveBtn {
  text-transform: inherit;
}
#stakingDiv #switchDiv {
  display: flex;
  align-items: center;
  justify-content: center;
}
#stakingDiv #switchDiv #noSpan,
#stakingDiv #switchDiv #yesSpan {
  color: #ffffff;
  letter-spacing: 1.8px;
  text-shadow: 0px 0px 4px #fffeab;
  font-family: Architects Daughter;
  font-size: 20px;
}
#stakingDiv #switchDiv #noSpan {
  margin-right: 15px;
}
#stakingDiv #meditateP {
  color: #ffffff;
  letter-spacing: 1.8px;
  font-family: Architects Daughter;
  font-size: 15px;
  text-align: center;
}
#stakingDiv #btnDiv {
  width: 100%;
  text-align: center;
  opacity: 0.9;
}
#stakingDiv #btnDiv #claimBtn {
  margin-top: 20px;
  text-transform: inherit;
  padding: 25px 30px;
}
#stakingDiv #lastUpdateP {
  text-align: center;
  margin-top: 10px;
}
#stakingDiv #syncAllChkDiv {
  position: absolute;
  right: 15px;
  top: 70px;
}
#stakingDiv #syncAllChkDiv #syncAllLabel {
  color: white;
  font-weight: bold;
}

#levelUpNFTsDiv #levelUpH1 {
  text-align: center;
  font-size: 30px;
  margin-top: 30px;
}
#levelUpNFTsDiv #levelUpNFTRow #nameP {
  text-align: center;
  color: #ffffff;
  font-weight: 600;
  font-family: Architects Daughter;
}
#levelUpNFTsDiv #levelUpNFTRow #btnsDiv {
  text-align: center;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/MyGurus/MgCoreSet.vue